var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNecklace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#221F1F;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M275.44,298.85c1.37-2.49,2.24-5.31,2.24-8.38v-30.25c0-0.25-0.08-0.5-0.08-0.71L500,4.9L487.47-6.02 L268.43,244.73c-2.53-1.37-5.39-2.24-8.47-2.24h-19.92c-3.11,0-6.02,0.87-8.59,2.32L12.53-5.85L0,5.06l222.4,254.57 c0,0.21-0.08,0.37-0.08,0.58v30.25c0,3.07,0.87,5.89,2.24,8.38c-45.73,11.41-79.68,52.83-79.68,102.01 c0,57.98,47.14,105.16,105.12,105.16s105.12-47.19,105.12-105.16C355.12,351.68,321.17,310.26,275.44,298.85z M250,457.63 c-31.29,0-56.73-25.48-56.73-56.77s25.44-56.73,56.73-56.73s56.73,25.44,56.73,56.73S281.29,457.63,250,457.63z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNecklace);
export default __webpack_public_path__ + "static/media/necklace.c4d819494d051829346a3400ff550f21.svg";
export { ForwardRef as ReactComponent };